module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAABACAYAAAAnBDaKAAAAAXNSR0IArs4c6QAAAMRJREFUSA3tVcENwjAMtC2Q6KtCMAL7P+HbPegGgfZF8jR2iiNHKRukUtTz3bXpWUkK4K6wfFiHo4B8sYe7YetK70Pvg98ffT309dDXg+/AhjGs8QnMt1YSBnEmBHjsiqqLRkh0/2sQDZl5eK3pDcBDbcR0PQ8XQsQk4lSLWvGkWt68AprvMC4bjkSNwbhsGMfTrJHKNIIzJ0Q5H3xcj4uB3DQel7dq3LDEqEOxCQcDGkl+7JPWio0vhp/QpKkMFs2e1vsX32A+VMhuuPsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/arrow.png
// module id = IHch
// module chunks = 1